<template>
  <div class="password_reset">
    <el-form :model="passwordModel" :rules="rules" ref="passwordForm">
      <!-- <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            v-model="passwordModel.oldPassword"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="passwordModel.newPassword"
          autocomplete="off"
          :type="flag ? 'text' : 'password'"
          size="small"
          maxlength="100"
        >
          <i
            slot="suffix"
            :class="[flag ? 'el-icon-minus' : 'el-icon-view']"
            autocomplete="auto"
            @click="flag = !flag"
          />
        </el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
          v-model="passwordModel.confirmPassword"
          autocomplete="off"
          :type="flag ? 'text' : 'password'"
          size="small"
          maxlength="100"
        >
          <i
            slot="suffix"
            :class="[flag ? 'el-icon-minus' : 'el-icon-view']"
            autocomplete="auto"
            @click="flag = !flag"
          />
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="submit('passwordForm')">确定修改</el-button>
    </span>
  </div>
</template>

<script>
import { passwordReset } from "api/user";
import { getCurrentInstance, ref, reactive, toRefs } from "@vue/composition-api";
export default {
  name: "PasswordReset",
  emits: ["closeDialog"],
  setup(props, { root, emit }) {
    /* data */
    const ctx = getCurrentInstance();
    const flag = ref(false);
    const passwordModel = reactive({
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    });
    const { newPassword, confirmPassword } = toRefs(passwordModel);
    const rules = reactive({
      oldPassword: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
      newPassword: [{ required: true, message: "请输入新密码", trigger: "blur" }],
      confirmPassword: [{ required: true, message: "请输入确认密码", trigger: "blur" }]
    });
    /* methods */
    const submit = formName => {
      if (newPassword.value !== confirmPassword.value) {
        root.$notify({
          type: "warning",
          message: "确认密码与新密码不一致!"
        });
        return;
      }
      ctx.refs[formName].validate(valid => {
        if (valid) {
          passwordReset({
            userId: root.$store.state.user.userId,
            pwd: newPassword.value
          }).then(res => {
            if (res.code == 200) {
              root.$notify({
                type: "success",
                message: "修改密码成功,请重新登录!"
              });
              root.$store.dispatch("user/logout").then(() => {
                root.$router.push({ path: "/login" });
              });
              emit("closeDialog");
            }
          });
        }
      });
    };
    return {
      flag,
      passwordModel,
      rules,
      submit
    };
  }
};
</script>
<style lang="scss" scoped>
.password_reset {
  .el-form {
    width: 66.6%;
    ::v-deep .el-form-item {
      .el-form-item__content {
        .el-input__suffix {
          right: 15px;
        }
      }
    }
  }
}
</style>
